  import dayjs from "dayjs";
  import utc from "dayjs/plugin/utc";
import { defaultSignalStatListData } from "utility/constants";
import TableContainer from "@mui/material/TableContainer/TableContainer";
import TableHead from "@mui/material/TableHead/TableHead";
import IconButton from "@mui/material/IconButton/IconButton";
import Table from "@mui/material/Table/Table";
import TableRow from "@mui/material/TableRow/TableRow";
import TableCell from "@mui/material/TableCell/TableCell";
import TableBody from "@mui/material/TableBody/TableBody";
import CloseIcon from '@mui/icons-material/Close';

  dayjs.extend(utc);
  
  const DefaultSignalTableData = (props: any) => {
    const headValues = Object.keys(defaultSignalStatListData);
    const data: any = Object.values(defaultSignalStatListData)
    return (
        <TableContainer>
        <Table aria-label="simple table" style={{ border: "1px solid #f6f6f6" }}>
            <TableHead>
                <IconButton
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={() => { props?.setDefaultSignalDataModalOpen(false) }}
                >
                    <CloseIcon />
                </IconButton>
                <TableRow style={{ backgroundColor: '#F6F6F6' }}>
                    <TableCell style={{ width: '25%' }}>CHANNEL</TableCell>
                    <TableCell style={{ width: '25%' }}>MIN VALUE</TableCell>
                    <TableCell style={{ width: '25%' }}>MAX VALUE</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {headValues.map((row: string, index: number) => (
                    <TableRow key={index}>
                        <TableCell component="th" scope="row" style={{ width: '25%' }}>{row}</TableCell>
                        <TableCell component="th" scope="row" style={{ width: '25%' }}>{data[index]?.min}</TableCell>
                        <TableCell component="th" scope="row" style={{ width: '25%' }}>{data[index]?.max}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
    )
  };

  export default DefaultSignalTableData;